import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractCustomerComponent } from '@df/account/v2/abstract-customer.component';
import { Address } from '@df/session/api/address-book/address';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import compact from 'lodash-es/compact';
import uniq from 'lodash-es/uniq';
import { AccountBackComponent } from '../../back/account-back.component';
import { AccountAddressItemComponent } from '../item/account-address-item.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
@Component({
    selector: 'account-address-book',
    templateUrl: './account-address-book.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, RouterLink, AccountBackComponent, CommonModule, AccountAddressItemComponent, GridModule, IfSizeDirective]
})
export class AccountAddressBookComponent extends AbstractCustomerComponent implements OnInit {
    /**
     * List of addresses
     */
    addresses?: Address[];
    protected override onCustomerDataChange(): void {
        const addressBook = this.customer.addressBook;
        this.addresses = compact(uniq([addressBook.shipping, addressBook.billing, ...addressBook.additional].filter(i => !!i)));
        super.onCustomerDataChange();
    }
}
